<template>
  <div id="loadDiv">
    <mt-header fixed title="传输列表" class="yp-topbar"></mt-header>
    <div class="loadDivList">
      <div v-if="fileList.wait.length + fileList.error.length + fileList.success.length != 0">
        <div v-if="fileList.wait.length !== 0">
          <div class="title">正在上传({{fileList.wait.length}})</div>
          <ul class="listDiv">
            <v-touch v-on:swipeleft="swiperight">
              <li v-for="(item,index) in fileList.wait" style="position: relative">
                <div class="list">
                      <span :class="styleObject(item.name)" v-if="sliceType(item.name)!=='package'">
                         <i :class="classObject(item.name)" class="iconfont"></i>
                     </span>
                  <svg class="icon package" aria-hidden="true" v-else>
                    <use xlink:href="#icon-package"></use>
                  </svg>
                  <div class="con">
                    <div class="right">
                      <h3>{{item.name | sliceNameF}}</h3>
                      <span>正在上传中</span>
                    </div>
                    <div class="size">{{item.size | bytesToSize}}</div>
                  </div>
                </div>
                <div class="list-shade" :style="{width: `calc(100% * ${item.progress})`}"></div>
              </li>
            </v-touch>
          </ul>
        </div>
        <div v-if="fileList.success.length !== 0">
          <div class="title">上传成功({{fileList.success.length}})</div>
          <ul class="listDiv">
            <li v-for="(item,index) in fileList.success">
              <v-touch v-on:swipeleft="swipeleft(index)" v-on:swiperight="swiperight(index)">
                <div class="list">
                       <span :class="styleObject(item.name)" v-if="sliceType(item.name)!=='package'">
                         <i :class="classObject(item.name)" class="iconfont"></i>
                       </span>
                  <svg class="icon package" aria-hidden="true" v-else>
                    <use xlink:href="#icon-package"></use>
                  </svg>
                  <div class="con">
                    <div class="right">
                      <h3>{{item.name | sliceNameF}}</h3>
                      <span>{{item.newDate | formatTime}}</span>
                    </div>
                    <div class="size">{{item.size | bytesToSize}}</div>
                  </div>
                </div>
                <div class="delete" v-show="index === delShow" @click="deleteFile(item, '1')">
                  删除
                </div>
              </v-touch>
            </li>
          </ul>
        </div>
        <div v-if="fileList.error.length !== 0">
          <div class="title">上传错误({{fileList.error.length}})</div>
          <ul class="listDiv">
            <v-touch v-on:swipeleft="swiperight">
              <li v-for="(item,index) in fileList.error">
                <div class="list">
                         <span :class="styleObject(item.name)" v-if="sliceType(item.name)!=='package'">
                         <i :class="classObject(item.name)" class="iconfont"></i>
                     </span>
                  <svg class="icon package" aria-hidden="true" v-else>
                    <use xlink:href="#icon-package"></use>
                  </svg>
                  <div class="con">
                    <div class="right">
                      <h3>{{item.name}}</h3>
                      <!--<span>{{item.newDate | formatTime}}</span>-->
                      <span style="color: red">上传失败，{{item.message}}</span>
                    </div>
                    <div class="size">{{item.size | bytesToSize}}</div>
                  </div>
                </div>
              </li>
            </v-touch>
          </ul>
        </div>
      </div>
      <div v-else id="noList" style="position: fixed;top: 40%;left: 30%">
        <i class="iconfont icon-meiyoushangchuan" style="color: #D4D4D4;font-size: 1.8rem"></i>
        <p style="font-size: .28rem;color: #999999">您还没有上传记录哦～</p>
      </div>
    </div>
    <tabbar :id="3"></tabbar>
  </div>
</template>

<script>
  import {Navbar, TabItem} from 'mint-ui'
  import tabbar from '@/components/tabbar.vue'
  import {sliceName} from '../../assets/js/tools'

  export default {
    name: 'transfer',
    data () {
      return {
        delShow: null,
        fileList: {
          success: this.$store.state.fileList.success,
          error: this.$store.state.fileList.error,
          wait: this.$store.state.fileList.wait
        }
      }
    },
    props: [],
    methods: {
      // 滑动事件
      swipeleft: function (index) {
        this.delShow = index
      },
      // 同上
      swiperight: function (index) {
        this.delShow = '-'
      },
      // 删除文件记录或取消文件上传事件
      deleteFile: function (file, type) {
        this.$store.commit('fileListRemove', {type: type, file: file})
        this.swiperight()
      },
      classObject (val) {
        let type = this.sliceType(val)
        return 'icon-' + type
      },
      sliceType: function (val) {
        if (val !== '' || val !== undefined) {
          var point = val.lastIndexOf('.')
          var type = val.substring(point + 1).toLowerCase()
          if (type === 'jpg' || type === 'gif' || type === 'JPG' || type === 'GIF' || type === 'png') {
            return 'pic'
          } else if (type === 'avi' || type === 'rmvb' || type === 'rm' || type === 'asf' || type === 'divx' || type === 'mpg' || type === 'mpeg' || type === 'mpe' || type === 'mp4' || type === 'mkv' || type === 'vob ') {
            return 'video'
          } else if (type === 'WAVE' || type === 'AIFF' || type === 'MPEG' || type === 'MP3' || type === 'MIDI' || type === 'mp3') {
            return 'muisc'
          } else if (type === 'txt') {
            return 'txt'
          } else if (type === 'pdf') {
            return 'pdf'
          } else if (type === 'doc' || type === 'docx') {
            return 'word'
          } else if (type === 'ppt' || type === 'pptx') {
            return 'ppt'
          } else if (type === 'xls' || type === 'xlsx') {
            return 'excel'
          } else if (type === 'html' || type === 'htm') {
            return 'html'
          } else if (type === 'wps' || type === 'wpt') {
            return 'wps'
          } else if (type === 'zip' || type === 'rar') {
            return 'package'
          } else {
            return 'default'
          }
        }
      },
      styleObject (val) {
        let type = this.sliceType(val)
        if (type === 'excel') {
          return 'excel'
        } else if (type === 'pdf') {
          return 'pdf'
        } else if (type === 'word') {
          return 'word'
        } else if (type === 'txt') {
          return 'txt'
        } else if (type === 'pic') {
          return 'pic'
        } else if (type === 'muisc') {
          return 'muisc'
        } else if (type === 'dir') {
          return 'dir'
        } else if (type === 'html') {
          return 'html'
        } else if (type === 'shareDir') {
          return 'shareDir1'
        } else {
          return 'weizhi'
        }
      }
    },
    created () {
      console.log(this.fileList.success)
    },
    components: {
      Navbar,
      TabItem,
      tabbar,
      sliceName
    },
    filters: {
      bytesToSize: function (bytes) {
        if (bytes === 0) return '0 B'
        if (bytes === '') return ''
        var k = 1024
        var sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
        var i = Math.floor(Math.log(bytes) / Math.log(k))
        return (bytes / Math.pow(k, i)).toPrecision(3) + sizes[i]
      },
      formatTime: function (val) {
        if (val !== '' || undefined || null) {
          return new Date(val).format('yyyy-MM-dd HH:mm')
        } else {
          return ''
        }
      },
      sliceNameF: function (val) {
        return val
        // return sliceName(val, 10)
      }
    }
  }
</script>
<style scoped rel="stylesheet/scss" lang="scss">
  @import "../../assets/css/variable";
  #loadDiv {
    position: absolute;
    width: 100%;
    overflow: scroll;
    padding-top: 1.28rem;
    padding-bottom: .98rem;
    height: 100%;

    header {
      font-size: 0.36rem !important;
      position: fixed;
      top: 0;
      width: 100%;
      height: 1.28rem;
      line-height: 0.88rem;
      -webkit-backdrop-filter: blur(40px);
      backdrop-filter: blur(40px);
      color: #fff;
      z-index: 999;
    }

    .loadDivList {
      height: 100%;
      overflow-y: scroll;
      background-color: #fff;
    }

    .iconfont {
      font-size: 0.62rem;
    }

    .title {
      width: 100%;
      height: .6rem;
      line-height: .6rem;
      background: #F7F7FA;
      font-size: .28rem;
      padding-left: .28rem;
      color: #666666;
    }

    .listDiv {
      li {
        border-bottom: 1px solid #e5e5e5;
        position: relative;
        background: #fff;
        .delete {
          height: 100%;
          width: 20%;
          color: #fff;
          position: absolute;
          right: 0;
          font-size: .3rem;
          top: 0;
          line-height: 1rem;
          text-align: center;
          background: red;
        }
      }
    }

    .list {
      padding-left: 0.3rem;
      width: 80%;
      height: 1rem;
      padding-top: .16rem;
      .con {
        display: inline-block;
        overflow: hidden;
        width: 70%;
        margin-left: 0.228rem;
        .size {
          position: absolute;
          right: 0.64rem;
          top: 0.4rem;
        }
        .right {
          h3 {
            font-size: .28rem;
            /*width: 3rem;*/
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            color: #1D1F22;
          }
          span {
            font-size: .2rem;
            color: #9B9B9B;
          }
        }
      }
    }
    .list-shade{
      position: absolute;
      top:0;
      left: 0;
      width: 0;
      background: rgba($theme-color, 0.1);
      height: 1rem;
    }

    #noList {
      text-align: center;
    }

    .excel {
      color: #36AB60;
    }

    .pdf {
      color: #E0620D;
    }

    .word {
      color: #2985FD;
    }

    .txt {
      color: #17ABE3;
    }

    .html {
      color: #EFC96D;
    }

    .pic {
      color: #3EA362;
    }

    .muisc {
      color: #EA5986;
    }

    .dir {
      color: #FED531;
    }
    .package {
      vertical-align: .1rem;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/transfer/transfer.vue